/* eslint-disable import/no-unresolved */
import { Button, Select, SelectOption } from 'appkit-react';
import { useState, useEffect } from 'react';
import { useMutation } from '@apollo/client';

import { UPDATE_PROJECT } from 'Apollo/Mutations/DataRecon';
import './UpdateStatus.scss';

const UpdateStatus = ({
    tenantId, project, refetch, setShowStatusDropdown, setToastMessage,
}) => {
    const [status, setStatus] = useState(null);

    /* apollo mutation to update the project's status */
    const [updateProject, { loading: projectUpdateloading }] = useMutation(UPDATE_PROJECT, {
        variables: {
            input: {
                projectId: parseInt(project.projectId, 10),
                projectName: project.projecName,
                projectDesc: project.projectDesc,
                userIdArr: project.userIdArr,
                ownerId: parseInt(project.ownerId, 10),
                tenantId: parseInt(tenantId, 10),
                status: status === 'Open' ? 'open' : 'resolved',
            },
        },
    });

    /* callback function on click of Save button */
    const updateStatus = async () => {
        await updateProject().then(() => setToastMessage('Project status is changed.'));
        refetch();
        setShowStatusDropdown(false);
    };

    useEffect(() => {
        if (project?.status === 'open') {
            setStatus('Open');
        } else {
            setStatus('Resolved');
        }
    }, [project.status]);

    return (
        <div>
            <div className="project-status-wraper">
                <span className="status-column">
                    <Select
                        size="default"
                        placeholder="Select"
                        onSelect={e => { setStatus(e); }}
                        value={status}
                        name="status"
                        className="project-status"
                    >
                        <SelectOption value="Open">Open</SelectOption>
                        <SelectOption value="Resolved">Resolved</SelectOption>
                    </Select>
                </span>
                <span className="status-btn-column">
                    <Button className="a-btn a-btn-primary" size="md" onClick={updateStatus} isLoading={projectUpdateloading}> SAVE </Button>
                </span>
            </div>
        </div>
    );
};

export default UpdateStatus;
